import type { FC } from 'react';
import apple from '../../assets/social/apple';
import discord from '../../assets/social/discord';
import email from '../../assets/social/email';
import facebook from '../../assets/social/facebook';
import github from '../../assets/social/github';
import google from '../../assets/social/google';
import linkedin from '../../assets/social/linkedIn';
import microsoft from '../../assets/social/microsoft';
import passkeySmartWallet from '../../assets/social/passkey';
import phone from '../../assets/social/phone';
import twitch from '../../assets/social/twitch';
import twitter from '../../assets/social/twitter';

const iconMap: Record<string, FC> = {
  apple,
  discord,
  email,
  facebook,
  github,
  google,
  linkedin,
  microsoft,
  passkeySmartWallet,
  phone,
  twitch,
  twitter,
};

const SocialIcon = ({ authType }: { authType: string }) => {
  const Icon = iconMap[authType];
  return Icon ? <Icon /> : null;
};

export default SocialIcon;
